<template>
  <router-link
    class="group-link-node"
    :to="groupPath"
    :class="{ 'group-link-node--loading': loading }"
  >
    <ContentLine
      :text="groupName"
      :icon="isTagGroup ? 'local_offer' : 'group'"
      font-icon
      :icon-tooltip="isTagGroup ? 'Tag Group' : 'Group'"
      tooltip
      :loading="loading"
    >
      <template v-if="showContactCount && group" v-slot:actions>
        <GroupContactsCountBadge :group="group" />
      </template>
    </ContentLine>
  </router-link>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GroupContactsCountBadge from '@/views/groups/components/GroupContactsCountBadge';

export default {
  name: 'GroupLinkNode',
  components: {
    GroupContactsCountBadge,
  },
  props: {
    nodeId: String,
    editMode: Boolean,
    groupId: {
      type: String,
      required: true,
    },
    showContactCount: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['singleGroup']),
    group() {
      return this.singleGroup(this.groupId);
    },
    groupName() {
      return this.group?.name || 'Loading...';
    },
    groupPath() {
      return {
        name: 'group-edit',
        params: { id: this.groupId },
      };
    },
    isTagGroup() {
      return this.group?.type === 'tag';
    },
  },
  watch: {
    groupId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchGroupIfNeeded();
        }
      },
    },
  },
  methods: {
    ...mapActions(['loadSingleGroup']),
    async fetchGroupIfNeeded() {
      if (this.group || !this.groupId) return;

      try {
        this.loading = true;
        await this.loadSingleGroup(this.groupId);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less">
.group-link-node {
  display: block;
  background-color: #fff;
  border-radius: 4px;
  text-decoration: none;
  transition: box-shadow 0.2s ease;
  border: 1px solid whiteSmoke;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &--loading {
    opacity: 0.7;
  }

  .content-line {
    min-height: 48px;
  }

  .content-line__icon .v-icon {
    color: var(--v-primary-base) !important;
  }
}
</style>
